import { I18nProvider } from 'providers/I18nProvider'
import { StoreProvider } from 'providers/StoreProvider'
import { QueryProvider } from 'providers/QueryProvider'
import { ThemeProvider } from 'providers/ThemeProviders'
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router'
import { AreasPageProtected } from 'pages/AreasPage'
import { WidgetPage } from 'pages/WidgetPage'
import { AreaPageProtected } from 'pages/AreaPage'
import { LoginPage } from 'pages/LoginPage'
import { AreaBlockPageProtected } from 'pages/AreaBlockPage'
import { AreaLayout } from 'pages/AreaLayout'
import { ModalProvider } from 'providers/ModalProvider'
import { RegisterPage } from 'pages/RegisterPage'
import { ToastContainer } from 'react-toastify'
import { AuthenticatedLayout } from 'components/ui/AuthenticatedLayout'
import { ResetPasswordPage } from 'pages/ResetPasswordPage'

export const App = () => {
  const routes: RouteObject[] = [
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'register',
      element: <RegisterPage />,
    },
    {
      path: 'reset-password',
      element: <ResetPasswordPage />,
    },
    {
      path: '/authenticated',
      element: <AuthenticatedLayout />,
      children: [
        {
          path: 'areas',
          element: <AreasPageProtected />,
        },
        {
          path: 'areas/:areaId',
          element: <AreaLayout />,
          children: [
            {
              path: '',
              element: <AreaPageProtected />,
            },
            {
              path: 'blocks/:blockId',
              element: <AreaBlockPageProtected />,
              id: 'blockId',
            },
          ],
        },
      ],
    },
    {
      path: '/',
      element: <WidgetPage />,
    },
    {
      path: '*',
      element: <WidgetPage />,
    },
  ]

  const router = createBrowserRouter(routes)

  return (
    <I18nProvider>
      <QueryProvider>
        <StoreProvider>
          <ThemeProvider>
            <ModalProvider>
              <RouterProvider router={router} />
              <ToastContainer />
            </ModalProvider>
          </ThemeProvider>
        </StoreProvider>
      </QueryProvider>
    </I18nProvider>
  )
}
